/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable no-nested-ternary */ /* eslint-disable camelcase */ /* eslint-disable no-unused-vars */ /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable react/prop-types */ import React, {
  useState,
  useContext,
} from 'react';
import { useTranslation } from 'react-i18next';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import moment from 'moment-timezone';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { TYPE_OPTIONS } from '../sales/util/constants/index';
import api from '../../service/axios/api';
import Loading from '../../components/loading/Loading';
import FlashContext from '../../components/contexts/FlashContext';




const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  table: {
    minWidth: 1100,
  },
});

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: '#303474',
    color: 'white',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

// eslint-disable-next-line import/prefer-default-export
export function CostCenterTableRow({ docs, searchData }) {
  const { t } = useTranslation();
  const { notifyError, notifySuccess } = useContext(FlashContext);
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);

  const [openEdit, setOpenEdit] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [type, setType] = useState('');

  const [openDelete, setOpenDelete] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const handleMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleEdit = async () => {
    if (name.length === 0 && code.length === 0) {
      notifyError(t('costCenters.editDialog.errors.empty'));
      return;
    }
    setLoadingEdit(true);

    try {
      const res = await api.costCenter.edit(docs.id, name, code, type);
      notifySuccess(res.data.message);
      setName('');
      setCode('');
      setType('')
      setOpenEdit(false);
      searchData();
    } catch (error) {
      notifyError(error.message);
      console.log(error);
    } finally {
      setLoadingEdit(false);
      setAnchorEl(null);
    }
  };

  const handleDelete = async () => {
    setLoadingDelete(true);

    try {
      const res = await api.costCenter.delete(docs.id);
      notifySuccess(res.data.message);
      setOpenDelete(false);
      searchData();
    } catch (error) {
      notifyError(error.message);
      console.log(error);
    } finally {
      setLoadingDelete(false);
      setAnchorEl(null);
    }
  };

  return (
    <>
      <StyledTableRow key={docs.id}>
        <StyledTableCell>{docs.name || '-'}</StyledTableCell>
        <StyledTableCell>{docs.code || '-'}</StyledTableCell>
        <StyledTableCell
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          {docs.created_at &&
            moment(docs.created_at).format('DD/MM/YYYY HH:mm')}
          <MoreVertIcon
            onClick={e => handleMenu(e)}
            fontSize="small"
            style={{ cursor: 'pointer' }}
          />
        </StyledTableCell>
      </StyledTableRow>
      <Menu
        id="menu-appbar"
        style={{ borderRadius: '25px' }}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          className={classes.textNotification}
          onClick={() => {
            setName(docs.name || '');
            setCode(docs.code || '');
            setType(docs.type || '');
            setOpenEdit(true);
          }}
        >
          {t('costCenters.table.menu.edit')}
        </MenuItem>
        <MenuItem
          className={classes.textNotification}
          onClick={() => setOpenDelete(true)}
        >
          {t('costCenters.table.menu.delete')}
        </MenuItem>
      </Menu>
      <Dialog
        onClose={() => setOpenEdit(false)}
        open={openEdit}
        fullWidth
        maxWidth="sm"
      >
        <Loading open={loadingEdit} msg={t('costCenters.editDialog.loading')} />
        <DialogTitle id="simple-dialog-title">
          {t('costCenters.editDialog.title')}
        </DialogTitle>
        <DialogContent>
          <Grid
            container
            spacing={4}
            style={{
              justifyContent: 'center',
            }}
          >
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                label={t('costCenters.filter.options.name')}
                variant="outlined"
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                label={t('costCenters.filter.options.code')}
                variant="outlined"
                value={code}
                onChange={e => setCode(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            style={{ height: 40 }}
            onClick={() => setOpenEdit(false)}
            variant="text"
            color="primary"
          >
            {t('costCenters.createDialog.buttons.cancel')}
          </Button>
          <Button
            style={{ height: 40 }}
            onClick={handleEdit}
            variant="contained"
            color="primary"
          >
            {t('costCenters.editDialog.buttons.edit')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        onClose={() => setOpenDelete(false)}
        open={openDelete}
        fullWidth
        maxWidth="sm"
      >
        <Loading
          open={loadingDelete}
          msg={t('costCenters.deleteDialog.loading')}
        />
        <DialogTitle id="simple-dialog-title">
          {t('costCenters.deleteDialog.title')}
        </DialogTitle>
        <DialogContent>
          <Grid
            container
            spacing={4}
            style={{
              justifyContent: 'center',
            }}
          >
            <Grid item xs={12} sm={8}>
              <p
                style={{
                  fontSize: '20px',
                  textAlign: 'justify',
                }}
              >
                {`${t('costCenters.deleteDialog.message1')}${docs.name}?${t(
                  'costCenters.deleteDialog.message2',
                )}`}
              </p>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            style={{ height: 40 }}
            onClick={() => setOpenDelete(false)}
            variant="text"
            color="primary"
          >
            {t('costCenters.createDialog.buttons.cancel')}
          </Button>
          <Button
            style={{ height: 40, backgroundColor: 'red', color: 'white' }}
            onClick={handleDelete}
            variant="contained"
          >
            {t('costCenters.deleteDialog.buttons.delete')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
